module.exports = __webpack_public_path__ + "img/success.7698578a.png";